import { createRouter, createWebHistory } from "vue-router";
import ConfirmSubscriptionPage from "@/views/ConfirmSubscriptionPage.vue";
import ErrorPage from "@/views/ErrorPage.vue";
import LandingPageResolver from "@/views/LandingPage/LandingPageResolver.vue";
import SubmitOtpPage from "@/views/SubmitOtpPage.vue";
import ThankYouPageResolver from "@/views/ThankYouPage/ThankYouPageResolver.vue";

const routes = [
  {
    path: "/",
    name: "Landing",
    component: LandingPageResolver,
  },
  {
    path: "/moving",
    name: "LandingMoving",
    component: LandingPageResolver,
  },
  {
    path: "/error",
    name: "Error",
    component: ErrorPage,
  },
  {
    path: "/thank-you",
    name: "ThankYou",
    component: ThankYouPageResolver,
  },
  {
    path: "/submit-otp",
    name: "SubmitOtp",
    component: SubmitOtpPage,
  },
  {
    path: "/confirm-subscription",
    name: "ConfirmSubscription",
    component: ConfirmSubscriptionPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
